import { render, staticRenderFns } from "./EditPropertyModal.vue?vue&type=template&id=12cd1226&"
import script from "./EditPropertyModal.vue?vue&type=script&lang=js&"
export * from "./EditPropertyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports